/*
 * @Date: 2019-06-03 11:36:42
 * @LastEditors: zwj
 * @LastEditTime: 2023-08-07 17:15:12
 */
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import globals from '@/globals'

// Layouts
import Layout from '@/layout/appLayout'
import Blank from '@/layout/blank'

// method
import {
  removeUserInfo,
  getUserBizInfo
} from '@/utils/storage'


Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: () => import('@/views/Login/index')
    },
    {
      path: '',
      redirect: '/news'
    },
    {
      path: '/dashboard',
      component: Layout,
      children: [
        {
          title: '仪表盘',
          path: '',
          icon: 'fas fa-clipboard-list',
          component: () => import('@/views/Dashboard/index')
        }
      ]
    },
    {
      path: '/newsDetail',
      component: () => import('@/views/News/detail')
    },
    {
      path: '/eventDetail',
      component: () => import('@/views/ActivityManage/eventDetail')
    },
    
    {
      path: '/activities',
      redirect: '/activities/list',
      title: '活动',
      icon: 'fas fa-flag',
      component: Layout,
      children: [
        {
          title: '活动列表',
          path: 'list',
          component: Blank,
          children: [
            {
              path: '',
              component: () => import('@/views/ActivityManage/list')
            },
            {
              path: 'info',
              component: () => import('@/views/ActivityManage/info')
            }
          ]
        }
      ]
    },
    {
      title: '资讯',
      icon: 'fas fa-building',
      component: Layout,
      path: '/news',
      redirect: '/news/list',
      component: Layout,
      children: [
        {
          title: '资讯',
          path: 'list',
          component: Blank,
          children: [
            {
              path: '',
              component: () => import('@/views/News/list')
            }
          ]
        }
      ]
    },
    {
      path: '/users',
      component: Layout,
      children: [
        {
          title: '用户管理',
          path: 'list',
          component: Blank,
          children: [
            {
              path: '',
              component: () => import('@/views/UserManage/list')
            },
          ]
        }
      ]
    },
    {
      path: '/systeam_management/',
      redirect: '/systeam_management/super_setting',
      title: '系统管理',
      icon: 'fas fa-building',
      component: Layout,
      children: [
        {
          title: '超级管理员设置',
          path: 'super_setting',
          component: () => import('@/views/adminSystemManage/superList')
        },
        {
          title: '活动分类',
          path: 'activity_classification',
          icon: 'fas fa-list-ul',
          component: () => import('@/views/ActivityManage/event')
        },
        {
          title: '活动区域',
          path: 'activity_area',
          icon: 'fas fa-list-ul',
          component: () => import('@/views/ActivityManage/area')
        },
		{
			title: '轮播图设置',
			path: 'carousels',
			icon: 'fas fa-list-ul',
			component: () => import('@/views/globalSetting/index')
		  }
      ]
    },
    {
      path: '/security_audit/',
      redirect: '/security_audit/operation_logs',
      title: '安全审计',
      icon: 'fas fa-building',
      component: Layout,
      children: [
        {
          title: '登入记录',
          path: 'auth_list',
          component: () => import('@/views/SecurityAudit/authLogs')
        },
        {
          title: '操作记录',
          path: 'operation_logs',
          component: () => import('@/views/SecurityAudit/operationLogs')
        }
      ]
    }
  ]
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')
  next()

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)

  let userInfo = getUserBizInfo()
  // console.log(to,userInfo)
  if (to.path === '/login' || to.path === '/newsDetail' || to.path === '/eventDetail') {
    if (userInfo && userInfo.token) {
      next({
        path: from.path
      })
      return
    }

    next()
    return
  }else{
    if(!userInfo || !userInfo.token){
      next({
        path: '/login'
      })
      return
    }
    next()
    return
  }

})

export default router
